import { mount } from 'svelte'

import App from './App.svelte'
import './app.css'
import 'maplibre-gl/dist/maplibre-gl.css'
import { isNativeShell } from './lib/native'
import { initPwa } from './lib/pwa.svelte'

const target = document.getElementById('app')
if (!target) throw new Error('#app missing from index.html')

const app = mount(App, { target })

// After load: registering the worker competes with the first tiles otherwise.
// The iOS app has no service worker; its native cache does that job.
if (!isNativeShell()) {
  if (document.readyState === 'complete') initPwa()
  else window.addEventListener('load', initPwa, { once: true })
}

export default app
